import React from "react";
import { GeoButtonWrapper, MenuGeoButtonWrapper } from "./styles";
import { MdDirectionsWalk } from "react-icons/md";
import { AiOutlineCar } from "react-icons/ai";
import { BiTrain } from "react-icons/bi";
import { ReactSVG } from "react-svg";
import svgSource from "views/resources/icons/turnRight.svg";
import { goToMap } from "lib/geolocation";
import { Menu, Dropdown } from "antd";

const menu = (onClick) => (
	<MenuGeoButtonWrapper>
		<Menu.Item key="0" onClick={() => onClick("walking")}>
			<span>
				<MdDirectionsWalk className="span__label_button" />
				Caminando
			</span>
		</Menu.Item>
		<Menu.Divider />
		<Menu.Item key="1" onClick={() => onClick("driving")}>
			<span>
				<AiOutlineCar className="span__label_button" />
				Automóvil
			</span>
		</Menu.Item>
		<Menu.Divider />

		<Menu.Item key="3" onClick={() => onClick("transit")}>
			<span>
				<BiTrain className="span__label_button" />
				Transporte público
			</span>
		</Menu.Item>
	</MenuGeoButtonWrapper>
);

export const GeoButton = ({
	offLatitude,
	offLongitude,
	userLng,
	userLat,
	desktop,
	borderless,
	disabled,
}) => {
	const userCoords = { userLat, userLng };
	const officeCoords = { offLatitude, offLongitude };
	const onClick = (travelMode) => {
		goToMap(userCoords, officeCoords, travelMode);
	};
	return (
		<GeoButtonWrapper
			disabled={!disabled}
			desktop={desktop}
			borderless={borderless}
		>
			<Dropdown
				overlay={() => menu(onClick)}
				trigger={["click"]}
				placement="bottomCenter"
				disabled={!disabled}
			>
				<button>
					<ReactSVG src={svgSource} /> Cómo llegar
				</button>
			</Dropdown>
		</GeoButtonWrapper>
	);
};
